
<template>
  <div>
    <div class="confirm-box" v-for="(item, index) in tableData" :key="index">
      <el-form
        :disabled="status === 'detail'"
        class="confirm-info-form"
        ref="confirmInfoForm"
        :model="item"
        :inline="true"
        label-width="100px"
        size="mini"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="品类" prop="productType">
              <DictSelect
                type="cml_sample_type"
                :value="item.productType"
                :excludes="['GIFT_MATERIAL']"
                @change-emit="productTypeChange($event, index, 1)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品名称" prop="productName">
              <el-input
                class="small-input-padding"
                size="mini"
                v-model="item.productName"
                :maxlength="maxlength30"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="position: relative;">
            <el-form-item label="数量" prop="num">
              <el-input-number
                v-model="item.num"
                :min="1"
                :precision="0"
                :step="1"
                :max="sampleDetail(item.productType, 'max')"
              />
              {{ sampleDetail(item.productType, 'unitName') }}
            </el-form-item>
            <span class="sample-tooltip" v-if="item.productType">({{sampleDetail(item.productType, 'btnTips')}})</span>
          </el-col>
          <el-col :span="8">
            <el-form-item label="需求品牌" prop="demandBrand">
              <DictSelect
                type="cml_brand"
                :value="item.demandBrand"
                @change-emit="value => (item.demandBrand = value)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="采购审核" prop="purchaserCheck">
              <el-select
                v-model="item.purchaserCheck"
                size="mini"
                clearable
                filterable
                popper-append-to-body
              >
                <el-option
                  v-for="item in purchaserCheckData"
                  :key="item.account"
                  :value="item.id"
                  :label="item.loginName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="需求人员" required prop="demandStaffName">
              <el-input
                size="mini"
                v-model="item.demandStaffName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="要求到样时间" prop="askArrivalTime">
              <el-date-picker
                v-model="item.askArrivalTime"
                type="datetime"
                placeholder="选择时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="expireTimeOption"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="成本范围" prop="costRange">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.costRange"
                :maxlength="maxlength30"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用途" prop="purpose">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.purpose"
                :maxlength="maxlength100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="!item.hidePackagingMaterialRequirement">
            <el-form-item label="包材要求" prop="packagingMaterialRequirement">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.packagingMaterialRequirement"
                :maxlength="maxlength100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="!item.hideMaterialRequirement">
            <el-form-item label="料体要求" prop="materialRequirement">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.materialRequirement"
                :maxlength="maxlength100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其它要求" prop="otherRequirement">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.otherRequirement"
                :maxlength="maxlength100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="对标竞品" prop="bidding">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.bidding"
                :maxlength="maxlength100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="特殊备注" prop="specialRemark">
              <el-input
                type="textarea"
                size="mini"
                v-model="item.specialRemark"
                :maxlength="maxlength100"
                placeholder="1、如果有特殊打样要求，请备注;2、如果样品不是寄给采购，请备注"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件" prop="urlList" class="upload-file upload-file-outside">
              <UploadFile
                ref="uploadMultipleRef"
                btnName="附件"
                :multiple="true"
                :maxSize="100"
                :disabled="status === 'detail'"
                excelFileExtend=".pdf,.doc,.xls,.xlsx,.docx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、XLS、XLSX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="arr => (item.urlList = arr)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上级领导审批" prop="leadApproval" v-if="item.productType === 'RAW_MATERIAL'">
                <el-select v-model="item.leadApproval">
                  <el-option
                    v-for="user in leaderList"
                    :key="user.loginName"
                    :label="user.name"
                    :value="user.loginName"
                  ></el-option>
                </el-select>
              </el-form-item></el-col>
        </el-row>
        <div v-if="status === 'create'" class="operate-btn">
          <el-button
            size="mini"
            v-if="tableData.length > 1"
            @click="deleteRow(index)"
            >删除行</el-button
          >
          <el-button size="mini" @click="addRow(index)"> 添加行</el-button>
        </div>
      </el-form>
    </div>
    <div class="footer-btn" v-if="status !== 'detail'">
      <el-button
        size="mini"
        type="primary"
        @click="saveBtn"
        :loading="saveLoading"
        >提交</el-button
      >
      <el-button size="mini" @click="cancelBtn">取消</el-button>
    </div>
  </div>
</template>
<script>
import DictSelect from '@/components/DictSelect';
import UploadFile from '@/components/Upload/UploadFile.vue';
import { sampleVODetail } from '@/utils/pageInfo';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';

export default {
  components: {
    DictSelect,
    UploadFile,
  },
  props: {
    status: {
      type: String,
      default: 'create',
    },
  },
  data: vm => ({
    tableData: [],
    rules: {
      productName: [
        { required: true, message: '请输入产品名称', trigger: 'blur' },
      ],
      productType: [
        { required: true, message: '请选择品类', trigger: 'change' },
      ],
      num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
      askArrivalTime: [
        { required: true, message: '请选择要求到样时间', trigger: 'change' },
      ],
      costRange: [
        { required: true, message: '请输入成本范围', trigger: 'blur' },
      ],
      purpose: [{ required: true, message: '请输入用途', trigger: 'blur' }],
      demandBrand: [
        { required: true, message: '请选择需求品牌', trigger: 'change' },
      ],
      purchaserCheck: [
        { required: true, message: '请选择采购审核', trigger: 'change' },
      ],
      leadApproval: [
        { required: true, message: '请选择上级领导审批', trigger: 'change' }
      ]
    },
    expireTimeOption: {
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
    rowData: {
      code: '',
      productName: '',
      productType: '',
      num: 1,
      askArrivalTime: dayjs().add(3, 'day').format('YYYY-MM-DD HH:mm:ss'),
      costRange: '',
      packagingMaterialRequirement: '',
      materialRequirement: '',
      otherRequirement: '',
      bidding: '',
      urlList: [],
      purpose: '',
      specialRemark: '',
      demandStaff: vm.$store.getters.userSelf.user.id,
      demandStaffName: vm.$store.getters.userSelf.user.name,
      demandBrand: JSON.stringify(vm.$store.getters.userSupplier.brand),
      purchaserCheck: '',
      leadApproval: ''
    },
    maxlength30: 30,
    maxlength100: 100,
    purchaserCheckData: [],
    action: '',
    fileList: [],
    saveLoading: false,
    checkParamsData: {
      productName: '产品名称',
      productType: '品类',
      num: '数量',
      askArrivalTime: '要求到样时间',
      costRange: '成本范围',
      purpose: '用途',
      demandBrand: '需求品牌',
      purchaserCheck: '采购审核',
    },
    leaderList: []
  }),
  mounted() {
    this.getUserListAll();
    if (this.status === 'create') {
      this.tableData.push(cloneDeep(this.rowData));
    }
    this.getUser();
  },
  methods: {
    getUser() {
      this.$http.leadApprovalConfig
        .userList({})
        .then(result => {
          this.leaderList = result.data;
        })
    },
    sampleDetail(type, prop) {
      const obj = sampleVODetail.find(item => item.sampleType === type);
      return obj ? obj[prop] : prop === 'max' ? 1 : '';
    },
    // 修改时表格赋值
    getDetail(id) {
      this.$http.outsideSampleManage.getOrderDetail(id).then(result => {
        this.tableData.push(result.data);
        this.productTypeChange(result.data.productType, 0, result.data.num);
        this.$nextTick(() => {
          this.$refs.uploadMultipleRef[0].fileList = result.data.urlList.map(
            item => {
              return {
                fileName: item.name,
                fileUrl: item.url,
                id: item.id,
                orderId: item.orderId
              };
            },
          );
        });
      }).catch(err => {
        this.$message.error(err.msg);
      });
    },
    // 采购审核
    getUserListAll() {
      this.$http.setting.getUserListBuyer({ customerId: '0'}).then(res => {
        this.purchaserCheckData = res.data;
      });
    },
    addRow(index) {
      this.tableData.splice(index + 1, 0, cloneDeep(this.rowData));
      this.clearProductInfoForm();
    },
    deleteRow(index) {
      this.tableData.splice(index, 1);
      this.$refs.uploadMultipleRef[index].fileList = [];
      this.clearProductInfoForm();
    },
    // 表单校验
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    // 清空form表单
    clearProductInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.clearValidate();
        });
      });
    },
    saveBtn() {
      if (!this.checkFormValid()) {
        return;
      }
      // 到样时间校验
      const errArr1 = this.tableData.filter(item => dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).diff(dayjs(item.askArrivalTime)) > 0)
      if(errArr1.length > 0) {
        this.$message.error(`产品名称【${errArr1[0].productName}】的要求到样时间不能早于当前时间`);
        return;
      }
      const data = this.tableData.map(item => {
        item.urlList = item.urlList.map(el => {
          return {
            name: el.fileName || el.name,
            url: el.fileUrl || el.url,
            id: el.id || '',
            orderId: item.id || ''
          };
        });
        return item;
      });
      const url = this.status === 'create' ? 'batchCreate' : 'updateOrder';
      const params = this.status === 'create' ? data : data[0];
      this.saveLoading = true;
      this.$http.outsideSampleManage[url](params)
        .then(res => {
          this.$message.success(res.msg);
          this.$emit('cancel-btn');
          this.$emit('on-success');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    cancelBtn() {
      this.tableData = [];
      this.$emit('cancel-btn');
    },
    resetForm() {
      this.tableData = [cloneDeep(this.rowData)];
      this.clearProductInfoForm();
      this.$refs.uploadMultipleRef[0].fileList = [];
    },
    // 根据品类展示字段
    productTypeChange(val, index, num) {
      this.tableData[index].productType = val;
      this.tableData[index].num = num;
      delete this.tableData[index].hidePackagingMaterialRequirement;
      delete this.tableData[index].hideMaterialRequirement;
      // 如果品类选中膜布，不显示包材要求和料体要求；
      if(val === 'MEMBRANE_CLOTH') {
        this.tableData[index].packagingMaterialRequirement = '';
        this.tableData[index].materialRequirement = '';
        this.tableData[index].hidePackagingMaterialRequirement = true;
        this.tableData[index].hideMaterialRequirement = true;
      }
      // 如果品类选中原料，不显示包材要求；
      if(val === 'RAW_MATERIAL') {
        this.tableData[index].packagingMaterialRequirement = '';
        this.tableData[index].hidePackagingMaterialRequirement = true;
      }
      // 如果品类选中包材，不显示料体要求
      if(val === 'PACKING_MATERIAL') {
        this.tableData[index].materialRequirement = '';
        this.tableData[index].hideMaterialRequirement = true;
      }
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .confirm-box {
  position: relative;
  display: flex;
  padding: 10px;
  border-bottom: 1px dashed #ccc;
  .confirm-info-form {
    width: 100%;
  }
  .el-textarea__inner {
    width: 200px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-form-item__label {
    padding: 0 5px 0 0;
  }
  .el-col {
    min-height: 66px;
  }
}
.footer-btn {
  text-align: center;
  padding: 20px 0;
}
/deep/ .el-input-number {
  .el-input {
    width: 130px !important;
  }
  .el-input--mini {
    .el-input__inner {
      width: 130px !important;
    }
  }
}
.operate-btn {
  text-align: center;
  .el-button--text {
    padding: 0;
    margin: 0 10px;
    font-size: 14px;
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.fileItem {
  max-width: 250px;
}
/deep/ .upload-file {
  .el-form-item__content {
    width: 200px;
  }
}
/deep/ .upload-file-outside {
  .upload-tips-text {
    width: 160px;
    top: 0;
  }
}
.sample-tooltip {
  position: absolute;
  left: 250px;
  top: 9%;
  width: calc(100% - 245px);
  font-size: 12px;
  line-height: 16px;
  color: #AB0033;
}
</style>